import React, { useState, useEffect, useRef } from 'react';
import { useIdleTimer } from "./hooks/useIdleTimer";
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc, setDoc, onSnapshot, updateDoc, addDoc, serverTimestamp, collection } from 'firebase/firestore';
import './App.css';

// Firebase configuration - replace with your actual config
const firebaseConfig = {
  apiKey: "AIzaSyAFQScNvlGZOGzvfbhx0zspYcaFAYLI114",
  authDomain: "comfort-attendance-api.firebaseapp.com",
  databaseURL: "https://comfort-attendance-api.firebaseio.com",
  projectId: "comfort-attendance-api",
  storageBucket: "comfort-attendance-api.firebasestorage.app",
  messagingSenderId: "817219823138",
  appId: "1:817219823138:web:2c87f3da288822809bcc7b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function App() {
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState('');
  const [lockuser, setLockuser] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [lockStatus, setLockStatus] = useState('disabled');
  const [countdown, setCountdown] = useState(0);
  const [isLockActive, setIsLockActive] = useState(false);
  //const [status, setStatus] = useState("Active");
  
 const {idleTime} = useIdleTimer(() => {
    //setStatus("Idle for 10s ⚡ (auto action triggered)");
    if(user) handleLogout();
  }, 60_000); // 1 minute

  // Check if user is already logged in (from localStorage)
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));

      // Listen for lock status changes
      const lockRef = doc(db, 'lockControl', 'status');
      const unsubscribeLock = onSnapshot(lockRef, (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setLockStatus(data.status || 'disabled');
          if (data.status === 'enabled') {
            setCountdown(data.countdown);
            setLockuser(data.updatedBy);
            setIsLockActive(true);
          } else {
            setIsLockActive(false);
          }
        }
      });

      return () => unsubscribeLock();
    }
  }, []);

  const getPublicIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip; // e.g. "103.12.45.67"
    } catch (error) {
      console.error("Error fetching IP:", error);
      return null;
    }
  };


  //fetch IP Data
  const saveLockLog = async () => {
    try {
      //if (!isLockActive) {
      const ip = await getPublicIP();
      // Step 2: Get location from IP
      const locationResponse = await fetch(`https://ipapi.co/${ip}/json/`);
      const locationData = await locationResponse.json();

      await addDoc(collection(db, "lockLogs"), {
        username: user.username,
        action: "UNLOCK", //isLockActive ? "LOCK" : "UNLOCK",
        timestamp: serverTimestamp(),
        ip: ip,
        location: {
          city: locationData.city,
          region: locationData.region,
          country: locationData.country_name,
          lat: locationData.latitude,
          lon: locationData.longitude,
        },
      });
      console.log("Log saved:", user.username);
      //}
    } catch (error) {
      console.error("Error saving log:", error);
    }
  };
  //calling savelog
  useEffect(() => {
    if (isLockActive) {
      saveLockLog();
    }
  }, isLockActive);

  // Handle countdown timer
  useEffect(() => {
    let timer;
    if (isLockActive && countdown > 0) {
      //updateLockStatus('enabled', 20);
      timer = setTimeout(() => {
        setCountdown(countdown - 3);
        // Update the countdown in Firebase
        updateDoc(doc(db, 'lockControl', 'status'), {
          countdown: countdown - 3
        });
      }, 3000);
    } else if (countdown === 0 && isLockActive) {
      // Update lock status to disabled when countdown reaches 0
      updateLockStatus('disabled', 0);
      setIsLockActive(false);
    }

    return () => clearTimeout(timer);
  }, [countdown, isLockActive]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Check if user exists in the loginDetails collection
      const userDocRef = doc(db, 'loginDetails', username);
      const userDoc = await getDoc(userDocRef);
      //console.log(userData);
      //console.log("userDoc to save:", userDoc);
      if (!userDoc.exists()) {
        setError('User not found');
        setLoading(false);
        return;
      }

      const userData = userDoc.data();
      //console.log("User Data to save:", userData);
      // Check if password matches
      if (userData.password !== password) {
        setError('Invalid password');
        setLoading(false);
        return;
      }

      // Login successful
      const userInfo = {
        username: userData.username,
        name: userData.Name //|| username
      };

      setUser(userInfo);
      localStorage.setItem('user', JSON.stringify(userInfo));

      // Listen for lock status changes
      const lockRef = doc(db, 'lockControl', 'status');
      const unsubscribeLock = onSnapshot(lockRef, (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setLockStatus(data.status || 'disabled');
          if (data.status === 'enabled') {
            setCountdown(data.countdown);
            setIsLockActive(true);
          } else {
            setIsLockActive(false);
          }
        }
      });

    } catch (error) {
      setError('Login failed: ' + error.message);
    }

    setLoading(false);
  };
  
//   const usersnew = [
//   { name: "Mrs. Sharmila Ajit Jain", username: "101", password: "1122" },
//   { name: "Mr. Shivkumar Ganesh Iyer", username: "102", password: "2233" },
//   { name: "Mr. Visanji Rayshi Dedhia", username: "103", password: "3344" },
//   { name: "Mr. Chandrashekhar D. Jadhav", username: "201", password: "4455" },
//   { name: "Mr. Venkatesan Kumar", username: "202", password: "5566" },
//   { name: "Mr. Hemalata V. Raghavan", username: "203", password: "6677" },
//   { name: "Mr. Avinash R. Punjabi", username: "301", password: "7788" },
//   { name: "Smt. Radha Shriniwasan", username: "302", password: "8899" },
//   { name: "Mr. Seshadri Jagannathan", username: "303", password: "9900" },
//   { name: "K. Pal / M. Pal / G. B. Pal", username: "401", password: "1212" },
//   { name: "Mr. Sridhar R. & Mrs. Poorna B.", username: "402", password: "2323" },
//   { name: "Mr. L. Ganeshan", username: "403", password: "3434" },
//   { name: "Mr. Harshad R. Pandit", username: "501", password: "4545" },
//   { name: "Mrs. Sobha Seshan", username: "502", password: "5656" },
//   { name: "Mrs. Madhuri Prashant Sonawane", username: "503", password: "6767" },
//   { name: "Mr. Sundeep Hirji Gala", username: "601", password: "7878" },
//   { name: "Smt. Chandra P. Swarup", username: "602", password: "8989" },
//   { name: "Mr. L. Dwarakanath", username: "603", password: "9090" },
//   { name: "Mr. Nishit Praful Gogri", username: "701", password: "1331" },
//   { name: "Mr. Charudatta R. Garware", username: "702", password: "2442" },
//   { name: "Mr. Vidyadhar S. Vaidya", username: "703", password: "3553" },
//   { name: "Mrs. Asha Ashok Jadhav", username: "801", password: "4664" },
//   { name: "Mr. Prakash D. Shikhare", username: "802", password: "5775" },
//   { name: "Rahul Karnik", username: "803", password: "6886" },
//   { name: "Mr. Madanlal G. Kochar", username: "901", password: "7997" },
//   { name: "Dr. Yogesh Chaudhari", username: "903", password: "8668" }
// ];

// async function uploadUsers() {
//   try {
//     for (let usernew of usersnew) {
//       // Use username as document ID
//       await setDoc(doc(db, "loginDetails", usernew.username), {
//         name: usernew.name,
//         password: usernew.password,
//         username: usernew.username
//       });
//       console.log("Added:", usernew.username, usernew.name);
//     }
//     console.log("✅ All users uploaded successfully");
//   } catch (error) {
//     console.error("❌ Error uploading users:", error);
//   }
// }

  const handleLogout = () => {
    //uploadUsers();
    setUser(null);
    localStorage.removeItem('user');
    setUsername('');
    setPassword('');
  };

  const updateLockStatus = async (status, countdownValue) => {
    try {
      await setDoc(doc(db, 'lockControl', 'status'), {
        status,
        countdown: countdownValue,
        //updatedAt: new Date(),
        updatedBy: user.username
      }, { merge: true });
    } catch (error) {
      setError('Failed to update lock status');
    }
  };

  const activateLock = () => {
    updateLockStatus('enabled', 30);
    setCountdown(20);
    setIsLockActive(true);
  };

  if (!user) {
    return (
      <div className="app">
        <div className="login-container">
          <div className="login-header">
            <h1>Creative's Smart Lock</h1>
            <p>Please sign in to continue</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            {error && <div className="error-message">{error}</div>}

            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                inputMode="numeric"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                inputMode="numeric"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="demo-credentials">
            <p>Design & Development by Creative Cards & Solutions</p>
            <p>Support : 9320773330 / contactmanvir@gmail.com</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="control-container">
        <div className="control-header">
          <h1>Smart Lock Control</h1>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>

        <div className="lock-status">
          <div className={`lock-icon ${isLockActive ? 'unlocked' : 'locked'}`}>
            {isLockActive ? '🔓' : '🔒'}
          </div>

          <h5>Door is {isLockActive ? 'Unlocked' : 'Locked'}</h5>
          {isLockActive && (<h5>By {lockuser}</h5> )}
          {!isLockActive && (<h5>⏱ Idle Time: <b>{idleTime} sec</b></h5>)}


          {isLockActive && (
            <div className="countdown">
              
              <div className="countdown-text">Auto-locking in</div>
              <div className="countdown-timer">{countdown}s</div>
            </div>
          )}
        </div>

        <button
          onClick={activateLock}
          disabled={isLockActive}
          className="activate-btn"
        >
          {isLockActive ? 'Lock Active' : 'Unlock Now'}
        </button>

        <div className="user-info">
          <p>Signed in as ({user.username})</p>
          {/* <p>({user.name})</p>
          <p>({user.username})</p> */}
        </div>
      </div>
    </div>
  );
}

export default App;